import Footer from "../../components/footer/footer"
import StartupsLandingSections from "../../components/startups-landing/StartupsLandingSections"
import Header from "../../components/header/header"
import Hero from "../../components/hero/hero"
import styles from "../../shared/pageShell.module.css"

const StartupsPage = () => {
	return (
		<div className={styles.page}>
			<Header />
			<Hero />
			<StartupsLandingSections />
			<Footer />
		</div>
	)
}

export default StartupsPage
